export default __webpack_public_path__ + "static/media/eetlijst-darkmode.25bd1f53.png";